import validateToken from '../../helpers/validateToken';
import decode_auth_token from '../../helpers/decodeAuthToken';
import validatePermissions from '../../helpers/validatePermissions';
import isOwner from '../../helpers/isOwner';
import isPrimaryCampaign from '../../helpers/isPrimaryCampaign';
import isAuth from '../../helpers/isAuth';
import {cookies} from 'ks_data_protocol_ui';

var timeOut = null;
const auth  = {
    state: {
        auth_loading:                        true,
        auth:                                {
            suffix:   '__ksrms-',
            user:     {},
            token:    null,
            urlToken: null,
            isAuth:   false,
        },
        selected_campaigns:                  [],
        current_time_log_id:                 null,
        call_log_count:                      null,
        count_conversation_with_unread_msgs: null,
        task_list_count:                     null,
        user_join_count:                     null,
        single_campaign_mode:                null,
        // variable to watch and explicitly change on user input from multi-campaigns
        multi_campaign_input:                0
    },

    getters: {
        auth:               state => {
            return state.auth;
        },
        selected_campaigns: state => {
            return state.selected_campaigns;
        },
        /*selected_facility: (state) => {
                return state.selected_facility;
            },*/
        auth_loading:        state => {
            return () => {
                return state.auth_loading;
            };
        },
        current_time_log_id: state => {
            return () => {
                return state.current_time_log_id;
            };
        },
        call_log_count:      state => {
            return () => {
                return state.call_log_count;
            };
        },

        count_conversation_with_unread_msgs: state => {
            return () => {
                return state.count_conversation_with_unread_msgs;
            };
        },

        task_list_count:      state => {
            return () => {
                return state.task_list_count;
            };
        },
        user_join_count:      state => {
            return () => {
                return state.user_join_count;
            };
        },
        multi_campaign_input: state => {
            return state.multi_campaign_input;
        }
    },

    mutations: {
        async loadUserCurrentData(state) {
            let auth = app['auth'];
            if (!auth.isAuth) return;
            try {
                let res                                   = await getUserCurrentData(auth.token, app.activeMultiCampaigns || null);
                auth.user['current_data']                 = res;
                state.current_time_log_id                 = auth.user.current_data.current_time_log_id;
                state.call_log_count                      = auth.user.current_data.call_log_count;
                state.count_conversation_with_unread_msgs = auth.user.current_data.count_conversation_with_unread_msgs;
                state.task_list_count                     = auth.user.current_data.task_list_count;
                state.user_join_count                     = auth.user.current_data.user_join_count;
                window.localStorage.setItem('current_time_log_id', state.current_time_log_id);
            } catch (err) {
                console.log('RMS: ', err);
            }
        },
        async setAuth(state, auth) {
            cookies.setCookie('token', auth.token, 1);
            let isAuthAux       = isAuth();
            state.auth.token    = auth.token;
            state.auth.user     = auth.user;
            state.auth.urlToken = auth.urlToken;
            state.auth.isAuth   = isAuthAux;
            app['auth']         = JSON.parse(JSON.stringify(auth));

            app['auth']['isAuth']              = isAuthAux;
            app.auth.user['hasPermission']     = (modulePermissions = null, campaign_id = null) => {
                let hasPermission = validatePermissions(modulePermissions, campaign_id);
                return hasPermission.isValid;
            };
            app.auth.user['isOwner']           = (campaign_id = null) => {
                return isOwner(campaign_id);
            };
            app.auth.user['isPrimaryCampaign'] = (campaign_id = null) => {
                return isPrimaryCampaign(campaign_id);
            };
            if (auth.user.current_data) {
                state.current_time_log_id                 = auth.user.current_data.current_time_log_id;
                state.call_log_count                      = auth.user.current_data.call_log_count;
                state.count_conversation_with_unread_msgs = auth.user.current_data.count_conversation_with_unread_msgs;
                state.task_list_count                     = auth.user.current_data.task_list_count;
                state.user_join_count                     = auth.user.current_data.user_join_count;
                window.localStorage.setItem('current_time_log_id', state.current_time_log_id);
            }
        },
        setAuthUser(state, user) {
            state.auth.user = user;
        },
        setAuthToken(state, token) {
            state.auth.token = token;
        },
        setSelectedCampaigns(state, campaigns) {
            app['activeMultiCampaigns'] = campaigns;
            state.selected_campaigns    = campaigns;
        },
        setMultiCampaignInput(state, value) {
            state.multi_campaign_input = value;
        },
        setSingleCampaignMode(state, payload) {
            state.single_campaign_mode = payload;
        },
        setCurrentTimeLogId(state, index) {
            state.current_time_log_id = index ? parseInt(index) : index;
            window.localStorage.setItem('current_time_log_id', state.current_time_log_id);
        },
        setCallLogCount(state, index) {
            state.call_log_count = index ? parseInt(index) : index;
        },

        setCountConversationWithUnreadMsgs(state, index) {
            state.count_conversation_with_unread_msgs = index ? parseInt(index) : index;
        },

        setTaskListCount(state, index) {
            state.task_list_count = index ? parseInt(index) : index;
        },
        setUserJoinCount(state, index) {
            state.user_join_count = index ? parseInt(index) : index;
        },
        setAuthLoading(state, loading) {
            state.auth_loading = loading;
        },
    },

    actions: {
        login: ({state, rootState, commit, dispatch}, data) => {
            return new Promise(async (resolve, reject) => {
                try {
                    commit('setAuthLoading', true);

                    /* clean all previous sw registrations */
                    navigator.serviceWorker.getRegistrations().then(function (registrations) {
                        for (let registration of registrations) {
                            registration.unregister();
                        }
                    });

                    window.localStorage.removeItem(state.auth.suffix + 'token');
                    window.localStorage.removeItem(state.auth.suffix + 'urlToken');
                    window.localStorage.removeItem(state.auth.suffix + 'user');
                    window.localStorage.removeItem(state.auth.suffix + 'selectedCampaigns');
                    window.localStorage.removeItem(state.auth.suffix + 'selectedUserCampaignModeId');
                    window.localStorage.removeItem('current_time_log_id');

                    //save Token
                    window.localStorage.setItem(state.auth.suffix + 'token', data.token[0]);
                    window.localStorage.setItem(state.auth.suffix + 'urlToken', data.token[1]);
                    let userData = await dispatch('setAuthData', data.data);
                    // set Deafult Campign Mode
                    window.localStorage.setItem(
                        state.auth.suffix + 'selectedUserCampaignModeId',
                        userData.user.default_campaign_mode_id
                    );
                    let activeCampaignsByDefault = userData.user.data_campaigns;
                    if (userData.user.default_campaign_mode_id !== null) {
                        if (userData.user.default_campaign_mode_id != 0) {
                            let mode = userData.user.campaign_mode_list.find(cm => cm.id == userData.user.default_campaign_mode_id);
                            if (mode) {
                                let cpids                = mode.campaign_id_csv.split(',').map(id => parseInt(id));
                                activeCampaignsByDefault = userData.user.data_campaigns.filter(cp => cpids.includes(cp.id));
                            }
                        }
                    } else {
                        if (state.single_campaign_mode) {
                            activeCampaignsByDefault = userData.user.data_campaigns.filter(
                                cp => cp.id == userData.user.default_campaign_id
                            );
                        }
                    }
                    dispatch('setActiveMultiCampaigns', {
                        campaigns:           activeCampaignsByDefault,
                        loadUserCurrentData: false,
                    });
                    userData.user['current_data'] = await getUserCurrentData(data.token[0], activeCampaignsByDefault);
                    await commit('setAuth', userData);
                    commit('setCurrentTimeLogId', userData.user['current_data'].current_time_log_id);

                    //end from login
                    commit('setAuthLoading', false);
                    resolve(true);
                } catch (error) {
                    console.error(error);
                    commit('setAuthLoading', false);
                    reject(error);
                }
            });
        },

        authInit: ({state, rootState, commit, dispatch}, app_token) => {
            return new Promise(async (resolve, reject) => {
                commit('setAuthLoading', true);
                let auth     = {token: null, user: {}, urlToken: null};
                let token    = window.localStorage.getItem(state.auth.suffix + 'token');
                let urlToken = window.localStorage.getItem(state.auth.suffix + 'urlToken');
                if (token) {
                    auth.token    = token;
                    auth.urlToken = urlToken;
                    dispatch('valUser')
                        .then(async data => {
                            let user = await decode_auth_token();
                            if (isAuth()) {
                                console.log('app_version ==>', user.app_version, process.env.APP_VERSION);
                                //load campaigns for user
                                auth.user              = JSON.parse(window.localStorage.getItem(state.auth.suffix + 'user'));
                                //selected default multiple campaigns
                                let selected_campaigns = JSON.parse(
                                    window.localStorage.getItem(state.auth.suffix + 'selectedCampaigns')
                                );

                                if (selected_campaigns && selected_campaigns.length > 0) {
                                    commit('setSelectedCampaigns', selected_campaigns);
                                } else {
                                    dispatch('setActiveMultiCampaigns', {
                                        campaigns:           auth.user.data_campaigns,
                                        loadUserCurrentData: false,
                                    });
                                }
                                //load current data for user
                                try {
                                    auth.user['current_data'] = await getUserCurrentData(
                                        auth.token,
                                        selected_campaigns && selected_campaigns.length > 0 ? selected_campaigns : auth.user.data_campaigns
                                    );
                                    /*state.current_time_log_id = auth.user.current_data.current_time_log_id;
                                                  state.call_log_count = auth.user.current_data.call_log_count;
                                                  state.task_list_count = auth.user.current_data.task_list_count;
                                                  state.user_join_count = auth.user.current_data.user_join_count;
                                                  window.localStorage.setItem('current_time_log_id', state.current_time_log_id);*/
                                } catch (err) {
                                    console.log('RMS: ', err);
                                }
                            } else {
                                auth.user = user;
                                dispatch('setActiveMultiCampaigns', {
                                    campaigns:           user.campaigns ? user.campaigns : [],
                                    loadUserCurrentData: false,
                                });
                                commit('setSelectedCampaigns', user.campaigns);
                            }
                            auth.user['campaign_mode_list'] = await getUserCampaignModes(token);
                            await commit('setAuth', auth);
                            let current_time_log_id = parseInt(window.localStorage.getItem('current_time_log_id'));
                            commit(
                                'setCurrentTimeLogId',
                                current_time_log_id && current_time_log_id !== 'null' ? current_time_log_id : null
                            );
                            commit('setAuthLoading', false);
                            resolve(true);
                        })
                        .catch(async error => {
                            console.log('RMS: ', error);
                            await dispatch('anonymous', app_token);
                            commit('setAuthLoading', false);
                            reject(error);
                        });
                } else {
                    await dispatch('anonymous', app_token);
                    commit('setAuthLoading', false);
                    resolve(true);
                }
            });
        },

        anonymous({state, commit}, app_token) {
            return new Promise(async (resolve, reject) => {
                try {
                    commit('setAuthLoading', true);
                    setTimeout(async () => {
                        let anon = await app.sdk.rms.user_auth(app_token, {
                            user_name:   process.env.ANONYMOUS_USERNAME,
                            password:    process.env.ANONYMOUS_PASSWORD,
                            app_version: process.env.APP_VERSION,
                        });
                        let auth = {token: null, urlToken: null, user: {}, campaign: {}};
                        window.localStorage.setItem(state.auth.suffix + 'token', anon.user_permissions[0].token[0]);
                        window.localStorage.setItem(state.auth.suffix + 'urlToken', anon.user_permissions[0].token[1]);
                        let userData  = await decode_auth_token();
                        auth.token    = anon.user_permissions[0].token[0];
                        auth.urlToken = anon.user_permissions[0].token[1];
                        auth.user     = userData;
                        await commit('setAuth', auth);
                        commit('setSelectedCampaigns', auth.user.campaigns);
                        commit('setAuthLoading', false);
                        resolve(true);
                    }, 500);
                } catch (err) {
                    reject(err);
                }
            });
        },

        valUser({state, commit}) {
            return new Promise(async (resolve, reject) => {
                try {
                    let token = window.localStorage.getItem(state.auth.suffix + 'token');
                    await validateToken(token);
                    resolve(true);
                } catch (err) {
                    window.localStorage.removeItem(state.auth.suffix + 'token');
                    window.localStorage.removeItem(state.auth.suffix + 'urlToken');
                    window.localStorage.removeItem(state.auth.suffix + 'user');
                    window.localStorage.removeItem(state.auth.suffix + 'selectedCampaigns');
                    window.localStorage.removeItem('current_time_log_id');
                    await commit('setAuth', {token: null, user: {}});
                    commit('setSelectedCampaigns', []);
                    reject('Invalid Token');
                }
            });
        },

        async logout({state, commit, dispatch}) {
            try {
                //end Delete all sw installed --testing
                window.localStorage.removeItem(state.auth.suffix + 'token');
                window.localStorage.removeItem(state.auth.suffix + 'urlToken');
                window.localStorage.removeItem(state.auth.suffix + 'user');
                window.localStorage.removeItem(state.auth.suffix + 'selectedCampaigns');
                window.localStorage.removeItem(state.auth.suffix + 'selectedUserCampaignModeId');
                window.localStorage.removeItem('current_time_log_id');
                window.localStorage.removeItem('__ks-active-call');
                commit('setSelectedCampaigns', []);
                //delete data providers
                //await dispatch('anonymous', app.store.state.rms_ui.config.app_token);
            } catch (err) {
                console.log('RMS: ', err);
            }
        },

        setActiveMultiCampaigns({state, commit}, data) {
            let aux = Array.isArray(data);
            window.localStorage.setItem(state.auth.suffix + 'selectedCampaigns', JSON.stringify(aux ? data : data.campaigns));
            commit('setSelectedCampaigns', aux ? data : data.campaigns);
            if (aux || data.loadUserCurrentData) {
                if (timeOut) {
                    clearTimeout(timeOut);
                }
                timeOut = setTimeout(() => {
                    commit('loadUserCurrentData');
                }, 1000);
            }
        },

        async setAuthData({state, commit, dispatch}, data = null) {
            try {
                let tokenData    = await decode_auth_token(); //decode User token
                let primaryIndex = null;
                let primaryId    = null;
                for (let [index, cp] of data.campaign_list.entries()) {
                    cp['id']  = cp.campaign_id;
                    //take token data campaign Permissions
                    let cData = tokenData.campaigns.filter(c => c.id === cp.id);
                    if (cData && cData[0]) {
                        cp['permissions'] = cData[0].permissions;
                        cp.is_primary     = cData[0].primary;
                        cp.is_owner       = cData[0].owner;
                        if (cData[0].primary) {
                            primaryIndex = index;
                            primaryId    = cp['id'];
                        }
                    }
                }
                //pull in first the primary campaign
                if (primaryIndex !== null) {
                    let clone = JSON.parse(JSON.stringify(data.campaign_list[primaryIndex]));
                    data.campaign_list.splice(primaryIndex, 1);
                    data.campaign_list.unshift(clone);
                }
                //remove campaigns of Token data;
                delete tokenData.campaigns;
                //inizializate user data
                let _auth                              = {
                    token:    data.user_permissions[0].token[0],
                    user:     tokenData,
                    urlToken: data.user_permissions[0].token[1],
                };
                _auth.user['first_name']               = data.user_info[0].first_name;
                _auth.user['last_name']                = data.user_info[0].last_name;
                _auth.user['default_campaign_id']      = data.user_info[0].default_campaign_id || primaryId;
                _auth.user['default_campaign_mode_id'] =
                    typeof data.user_info[0].default_campaign_mode_id !== 'undefined'
                        ? data.user_info[0].default_campaign_mode_id
                        : null;
                _auth.user['single_campaign_mode']     = data.user_info[0].single_campaign_mode;
                commit('setSingleCampaignMode', data.user_info[0].single_campaign_mode);
                _auth.user['username']           = data.user_info[0].username ? data.user_info[0].username : null;
                _auth.user['data_campaigns']     = data.campaign_list;
                _auth.user['invitations']        = data.join_alert_details;
                _auth.user['campaign_mode_list'] = await getUserCampaignModes(data.user_permissions[0].token[0]);
                _auth.user['default_modes']      = data.user_default_modes;
                commit('setCurrentTimeLogId', data.user_info[0].current_time_log_id);
                window.localStorage.setItem(state.auth.suffix + 'user', JSON.stringify(_auth.user)); //to Do delet this;
                return _auth;
            } catch (err) {
                console.log('RMS: ', err);
                throw err;
            }
        },

        refresh_token({state, commit, dispatch}, params = null) {
            return new Promise(async (resolve, reject) => {
                try {
                    let sendData = {
                        campaign_id: null,
                        user_name:   app.auth.user.username || state.auth.user.username,
                        app_version: params && params.appVersion ? params.appVersion : process.env.APP_VERSION,
                    };

                    let data = await app.sdk['rms']['user_auth'](
                        window.localStorage.getItem(state.auth.suffix + 'token'),
                        sendData
                    );

                    //save Token
                    window.localStorage.removeItem(state.auth.suffix + 'token');
                    window.localStorage.removeItem(state.auth.suffix + 'urlToken');
                    window.localStorage.setItem(state.auth.suffix + 'token', data.user_permissions[0].token[0]);
                    window.localStorage.setItem(state.auth.suffix + 'urlToken', data.user_permissions[0].token[1]);
                    //decode User token
                    let userData          = await dispatch('setAuthData', data);
                    //select a campaign for id (creae a new campaign);
                    let selectedCampaigns = state.selected_campaigns;
                    if (params && params.selectCampaignId) {
                        let campaign          = data.campaign_list.filter(cp => cp.campaign_id === params.selectCampaignId)[0];
                        campaign['campaigns'] = [];
                        selectedCampaigns.push(campaign);
                        dispatch('setActiveMultiCampaigns', {
                            campaigns:           selectedCampaigns,
                            loadUserCurrentData: false,
                        });
                    }
                    userData.user['current_data'] = await getUserCurrentData(
                        data.user_permissions[0].token[0],
                        selectedCampaigns
                    );
                    await commit('setAuth', userData);
                    resolve(data.user_permissions[0].token[0]);
                } catch (err) {
                    reject(err);
                }
            });
        },
    },
};

const getUserCurrentData = async (token, campaigns = null) => {
    try {
        let res = await app.sdk['rms']['user_current_data_read'](token, {
            campaign_id: campaigns !== null ? campaigns.map(e => e.id).join() : null,
        });
        if (res.result_set[0].error_number === 0) {
            return res.read[0];
        } else {
            throw 'error';
        }
    } catch (err) {
        throw err;
    }
};

const getUserCampaignModes = async token => {
    try {
        let res = await app.sdk['rms']['campaign_mode_list'](token, {
            campaign_id:    -1,
            row_count_skip: 0,
            row_count_take: 999,
        });
        if (res.result_set[0].error_number === 0 && typeof res.list !== 'undefined') {
            return res.list;
        } else {
            throw [];
        }
    } catch (err) {
        throw err;
    }
};

export default auth;
